const expandedLeaderboardStyles = {
    container: `flex flex-col gap-[14px] w-full items-center justify-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-[90%] rounded-[8px] bg-themeShadowColor pb-3 max-h-[90vh] overflow-hidden
                screen-500:rotate-0 screen-500:max-h-[unset] screen-500:max-w-[480px] screen-500:min-w-[480px]
                sm:min-w-[600px] sm:max-w-[600px]
    `,
    table_wrapper: `flex flex-col justify-between gap-4 w-full overflow-auto px-4
                    screen-500:max-h-[80vh]
    `,
    leaderboard_wrapper: `grid gap-1 grid-cols-4
                          screen-430:grid-cols-4
                          screen-500:grid-cols-5
                          sm:grid-cols-6 
    `,
    no_leaderboard: `max-w-[150px]`,
    no_leaderboard_text: `text-[14px]`,
    dataRow: `flex rounded-[10px] min-h-[36px] w-full animate-pulse bg-gray-700`,
    top_summary_header: `w-full flex items-center justify-center gap-10`,
    header_text: `text-[15px] font-[400] flex items-center gap-2`,
    highlighted_header_text: `text-liveGamePrimaryColor`,
    top_players: `w-full flex items-center gap-5 justify-center`,
}

const rowStyles = {
    dataRow: `relative flex justify-between items-center py-[5px] rounded-[10px] min-h-[36px] w-full overflow-hidden`,
    rank: `flex-1 flex justify-center items-center font-[500] text-[14px]
         screen-500:text-[16px]
    `,
    trophyIcon: `w-[15px] h-[15px]
                screen-500:w-[20px] screen-500:h-[20px]
    `,
    rankDiv: `absolute left-[-2px] -translate-y-1/2 top-1/2 w-[6px] h-[20px] rounded-[5px]
            screen-500:h-[24px]
    `, 
    detailsImage: `max-w-[20px] max-h-[20px] w-[20px] h-[20px] rounded-full object-cover
                    screen-500:max-w-[30px] screen-500:max-h-[30px] screen-500:w-[30px] screen-500:h-[30px]
    `,
    goldRank: `bg-yellow-500`, 
    silverRank: `bg-gray-400`,
    bronzeRank: `bg-[#A6644F]`,
    username: `flex-1 font-[400] text-[12px] text-ellipsis whitespace-nowrap overflow-hidden pl-2
        screen-500:text-[15px]
    `,
    points: `flex-1 text-center font-[400] text-[12px]
            screen-500:text-[15px]
    `,
}

const playerCardStyles = {
    playerCard: `flex flex-col items-center gap-1`,
    playerImage: `object-cover w-full h-full`,
    player_name_label: `text-[10px] absolute bottom-0 left-0 bg-leaderboardPlayerLabel w-full px-[3px] whitespace-nowrap overflow-hidden text-ellipsis
                        screen-430:text-xs
    `,
    points: `text-[10px] font-[400] text-liveGamePrimaryColor
            screen-430:text-xs
    `,
    trophyIcon: `max-w-[22px] h-auto w-full`,
    rank: `text-[10px] font-[400]
           screen-430:text-xs
    `,
    playerImageWrpr: `rounded relative overflow-hidden h-[55px] w-[55px]
                      screen-430:h-[70px] screen-430:w-[70px]
    `,
    skeleton: `bg-gray-700 animate-pulse rounded`,
}

export { expandedLeaderboardStyles, rowStyles, playerCardStyles }